export function IsApproved(record, okcheck, field = '') {
  let res = false;
  if (okcheck !== undefined && field != okcheck) {
    if (record[okcheck] == '1') {
      res = true;
    }
  }
  return res;
}
